import dayjs from "dayjs";
import "dayjs/locale/cs";

dayjs.locale("cs");
